import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, featuredArticles, aboutData } from '@/mocks/lolita';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const categoryImages: Record<string, string> = {
  tianmei: 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20fashion%20pink%20pastel%20dress%20with%20lace%20ruffles%20and%20ribbons%2C%20soft%20dreamy%20aesthetic%2C%20kawaii%20Japanese%20street%20fashion%2C%20clean%20cream%20background%2C%20editorial%20photography%20with%20soft%20lighting%2C%20delicate%20feminine%20atmosphere&width=600&height=500&seq=cat-tianmei-card&orientation=landscape',
  gete: 'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20fashion%2C%20black%20lace%20dress%20with%20velvet%2C%20dark%20elegant%20aesthetic%2C%20cross%20motif%2C%20victorian%20inspired%2C%20cream%20background%2C%20editorial%20fashion%20photography%2C%20dramatic%20soft%20lighting&width=600&height=500&seq=cat-gete-card&orientation=landscape',
  gudian: 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20fashion%2C%20burgundy%20and%20cream%20elegant%20dress%2C%20victorian%20inspired%2C%20floral%20pattern%2C%20mature%20feminine%20aesthetic%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20soft%20lighting&width=600&height=500&seq=cat-gudian-card&orientation=landscape',
  'chuanda-jiqiao': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20styling%20tips%2C%20coordination%20guide%2C%20petticoat%20headpiece%20socks%20shoes%2C%20cream%20background%2C%20editorial%20fashion%20photography%2C%20clean%20soft%20lighting&width=600&height=400&seq=cat-chuanda-card&orientation=landscape',
  'rukeng-zhinan': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20beginner%20starter%20kit%2C%20first%20dress%20selection%2C%20size%20measurement%2C%20cute%20packaging%2C%20cream%20background%2C%20editorial%20photography%2C%20soft%20lighting&width=600&height=400&seq=cat-rukeng-card&orientation=landscape',
};

const articleImages: Record<string, string> = {
  'luolita-lishi-qiyuan': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20history%2C%20victorian%20era%20to%20harajuku%20street%2C%20evolution%20timeline%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20vintage%20lighting&width=500&height=300&seq=feat-luolita-lishi-qiyuan&orientation=landscape',
  'san-dafengge-quan-jiexi': 'https://readdy.ai/api/search-image?query=Three%20Lolita%20styles%20comparison%2C%20sweet%20gothic%20classic%20side%20by%20side%2C%20pink%20black%20burgundy%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display&width=500&height=300&seq=feat-san-dafengge-quan-jiexi&orientation=landscape',
  'luolita-pinpai-quangonglve': 'https://readdy.ai/api/search-image?query=Lolita%20brands%20collection%2C%20Japanese%20Chinese%20western%20brands%2C%20dress%20display%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20lighting&width=500&height=300&seq=feat-luolita-pinpai-quangonglve&orientation=landscape',
  'luolita-huazhuang-wanquan': 'https://readdy.ai/api/search-image?query=Lolita%20makeup%20guide%2C%20sweet%20gothic%20classic%20makeup%20looks%2C%20cosmetic%20display%2C%20cream%20background%2C%20editorial%20beauty%20photography&width=500&height=300&seq=feat-luolita-huazhuang-wanquan&orientation=landscape',
  'luolita-chahui-zhinan': 'https://readdy.ai/api/search-image?query=Lolita%20tea%20party%20guide%2C%20elegant%20table%20setting%2C%20girls%20in%20dresses%2C%20tea%20cups%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20soft%20lighting&width=500&height=300&seq=feat-luolita-chahui-zhinan&orientation=landscape',
  'siji-luolita-bibei': 'https://readdy.ai/api/search-image?query=Lolita%20wardrobe%20essentials%20four%20seasons%2C%20spring%20summer%20autumn%20winter%20outfits%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display&width=500&height=300&seq=feat-siji-luolita-bibei&orientation=landscape',
};

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '洛丽塔——经典少女风格完全指南',
    description:
      '洛丽塔是源自日本的华丽少女时尚风格，以蕾丝、蓬蓬裙与维多利亚美学为核心。深度解析洛丽塔历史起源、风格分类、穿搭技巧及入坑必备单品。',
    url: 'https://eachbill.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '洛丽塔风格指南',
      url: 'https://eachbill.cn/',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://eachbill.cn/' },
      ],
    },
  };

  return (
    <>
      <SEOHead
        title="洛丽塔——经典少女风格完全指南 | 甜美系·哥特系·古典系"
        description="洛丽塔是源自日本的华丽少女时尚风格，以蕾丝、蓬蓬裙与维多利亚美学为核心。深度解析洛丽塔历史起源、风格分类、穿搭技巧及入坑必备单品，帮助每一位热爱洛丽塔的女孩打造梦幻造型。"
        keywords="洛丽塔,洛丽塔穿搭技巧,洛丽塔风格分类,甜美系洛丽塔,哥特洛丽塔,洛丽塔裙子推荐,洛丽塔入坑指南"
        canonicalUrl="https://eachbill.cn/"
        schemaData={homeSchema}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20Lolita%20fashion%20collage%20with%20pastel%20pink%20lace%20dresses%20and%20ribbon%20details%2C%20dreamy%20soft%20atmosphere%2C%20victorian%20inspired%20silhouettes%2C%20artistic%20composition%20with%20flowers%20and%20pearls%2C%20feminine%20aesthetic%2C%20cream%20and%20blush%20color%20palette%2C%20editorial%20fashion%20photography&width=1600&height=800&seq=lolita-hero-main&orientation=landscape"
            alt="洛丽塔时尚风格"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
          <div className="relative z-10 w-full text-center px-4">
            <p className="text-accent-300 text-sm md:text-base font-medium tracking-widest mb-3">
              ✦ LOLITA STYLE GUIDE ✦
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
              洛丽塔——经典少女风格完全指南
            </h1>
            <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              从甜美系到哥特系，从古典系到穿搭技巧，为你揭开洛丽塔时尚的梦幻面纱
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/tianmei"
                className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm"
              >
                探索风格分类
              </Link>
              <Link
                to="/category/rukeng-zhinan"
                className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 hover:bg-white/25 transition-all duration-300 whitespace-nowrap text-sm"
              >
                新人入坑指南
              </Link>
            </div>
          </div>
        </section>

        {/* Category Showcase */}
        <section className="section-padding bg-background-50">
          <div className="container-custom">
            <div className="text-center mb-12">
              <p className="text-primary-500 text-sm font-medium tracking-wider mb-2">风格探索</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-800 mb-3">
                洛丽塔风格分类
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto text-sm leading-relaxed">
                了解洛丽塔的五大核心分类，找到最契合你气质的梦幻风格
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categories.slice(0, 3).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-xl overflow-hidden h-[340px] cursor-pointer"
                >
                  <img
                    src={categoryImages[cat.slug]}
                    alt={cat.name}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-accent-300 text-xs tracking-wider mb-1">{cat.englishName}</p>
                    <h3 className="text-white text-xl font-heading font-semibold mb-2">{cat.name}</h3>
                    <p className="text-white/70 text-xs leading-relaxed line-clamp-2">{cat.description}</p>
                    <span className="inline-flex items-center gap-1 text-white/90 text-xs font-medium mt-3 group-hover:text-accent-300 transition-colors">
                      了解更多 <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
              {categories.slice(3, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-xl overflow-hidden h-[260px] cursor-pointer"
                >
                  <img
                    src={categoryImages[cat.slug]}
                    alt={cat.name}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-accent-300 text-xs tracking-wider mb-1">{cat.englishName}</p>
                    <h3 className="text-white text-xl font-heading font-semibold mb-2">{cat.name}</h3>
                    <span className="inline-flex items-center gap-1 text-white/90 text-xs font-medium group-hover:text-accent-300 transition-colors">
                      了解更多 <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="section-padding bg-background-100">
          <div className="container-custom">
            <div className="text-center mb-12">
              <p className="text-primary-500 text-sm font-medium tracking-wider mb-2">精选内容</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-800 mb-3">
                热门文章推荐
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto text-sm leading-relaxed">
                为你精选最受欢迎的洛丽塔深度文章，从入门到进阶一网打尽
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={articleImages[article.slug]}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/category/rukeng-zhinan"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-foreground-700 font-medium rounded-full border border-background-300/60 hover:border-primary-300 hover:text-primary-600 transition-all duration-300 text-sm whitespace-nowrap"
              >
                查看更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* About Preview */}
        <section className="section-padding bg-background-50">
          <div className="container-custom">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-primary-500 text-sm font-medium tracking-wider mb-2">关于我们</p>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-800 mb-5">
                  为热爱洛丽塔的你而生
                </h2>
                <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                  {aboutData.brandIntro.slice(0, 180)}...
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-7">
                  {aboutData.stats.map((stat) => (
                    <div key={stat.label} className="text-center p-4 bg-background-100 rounded-lg">
                      <p className="text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.value}</p>
                      <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 text-sm whitespace-nowrap"
                >
                  了解更多关于我们 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="relative h-[400px] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20Lolita%20fashion%20community%20gathering%2C%20girls%20in%20beautiful%20lace%20dresses%20at%20tea%20party%2C%20warm%20atmosphere%2C%20flowers%20and%20tea%20cups%2C%20cream%20and%20blush%20tones%2C%20editorial%20photography%2C%20soft%20natural%20lighting&width=700&height=600&seq=about-preview-home&orientation=landscape"
                  alt="洛丽塔社区"
                  className="absolute inset-0 w-full h-full object-cover object-top rounded-xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="section-padding bg-primary-500">
          <div className="container-custom text-center">
            <div className="max-w-lg mx-auto">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-mail-send-line text-2xl text-white/90"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
                订阅洛丽塔风格周报
              </h2>
              <p className="text-white/80 text-sm mb-7 leading-relaxed">
                每周获取最新洛丽塔穿搭灵感、品牌上新资讯和独家折扣信息
              </p>
              <NewsletterForm />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [formUrl, setFormUrl] = useState('');

  useEffect(() => {
    setFormUrl('https://readdy.ai/api/form/d9u430t3pcjqs2fcslkg');
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注 ✦');
      setEmail('');
      return;
    }

    const formData = new FormData(form);
    try {
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && (parsed.code === 'OK' || !parsed.code)) {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注 ✦');
        setEmail('');
      } else {
        const meta = parsed?.meta as Record<string, string> | undefined;
        const errMsg = meta?.message || meta?.detail || text || '订阅失败，请稍后重试';
        setStatus('error');
        setMessage(String(errMsg));
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3">
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        readOnly
        aria-hidden="true"
        className="form-honeypot"
      />
      <input
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="输入你的邮箱地址"
        required
        className="flex-1 px-5 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/50 focus:bg-white/20 transition-all"
      />
      <button
        type="submit"
        className="px-7 py-3 bg-white text-primary-600 font-medium rounded-full hover:bg-white/90 transition-all duration-300 text-sm whitespace-nowrap"
      >
        立即订阅
      </button>
      {status !== 'idle' && (
        <p className={`text-xs mt-2 ${status === 'success' ? 'text-white/90' : 'text-white/80'}`}>
          {message}
        </p>
      )}
    </form>
  );
}